export class BaseFilterModel {
  filter: unknown;
  fields: string[] = [];
  limit = 15;
  page = 1;
  skip = 0;
  sort: string[] = [];
}
